module.exports = __webpack_public_path__ + "static/media/ic_previous.c5a30c1d.svg";